/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface RuleFormDataAgencyOrGroup
 */
export interface RuleFormDataAgencyOrGroup {
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof RuleFormDataAgencyOrGroup
     */
    group?: GuidIdAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof RuleFormDataAgencyOrGroup
     */
    agency?: GuidIdCodeAndLabel;
}

export function RuleFormDataAgencyOrGroupFromJSON(json: any): RuleFormDataAgencyOrGroup {
    return RuleFormDataAgencyOrGroupFromJSONTyped(json, false);
}

export function RuleFormDataAgencyOrGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleFormDataAgencyOrGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'group': !exists(json, 'group') ? undefined : GuidIdAndLabelFromJSON(json['group']),
        'agency': !exists(json, 'agency') ? undefined : GuidIdCodeAndLabelFromJSON(json['agency']),
    };
}

export function RuleFormDataAgencyOrGroupToJSON(value?: RuleFormDataAgencyOrGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'group': GuidIdAndLabelToJSON(value.group),
        'agency': GuidIdCodeAndLabelToJSON(value.agency),
    };
}


